import React from "react";
import { Link } from "react-router-dom";
import AppStoreButtons from "@/components/AppStoreButtons";
import { PhoneTrio } from "@/components/PhoneFrame";
import { dharmaApp } from "@/data/app";

// The indigo ground of the app itself, with a low warm glow behind the phones.
export const APP_GROUND = {
  background:
    "radial-gradient(55% 75% at 74% 58%, rgba(92,62,22,0.55), rgba(6,9,20,0) 70%), #060914",
};

// On a phone the trio is wider than the screen so the centre phone is large and
// the side phones run off the edges; from sm up it is centred, from lg it sits right.
export const TRIO_BOX =
  "w-[140%] -ml-[20%] sm:w-full sm:mx-auto max-w-[680px] xl:max-w-[780px] lg:ml-auto lg:mr-0";

export function AppPrice({ className = "" }) {
  const a = dharmaApp;
  return (
    <p className={`font-body text-[13px] tracking-widest2 uppercase ${className}`}>
      <span>{a.price}</span>
      <span className="hidden sm:inline lg:hidden"> · {a.platforms}</span>
    </p>
  );
}

// Home section for the Dharma app.
export default function AppShowcase() {
  const a = dharmaApp;
  return (
    <section className="text-cream overflow-hidden" style={APP_GROUND}>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 py-12 md:py-16 xl:py-20 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-6 items-center">
        <div className="lg:col-span-5 md:text-center lg:text-left">
          <div className="flex items-center gap-4 mb-4 md:mb-6 md:justify-center lg:justify-start">
            <img
              src={a.icon}
              alt=""
              width="56"
              height="56"
              className="w-11 h-11 md:w-14 md:h-14 rounded-xl md:rounded-[14px] shadow-lg"
            />
            <p className="eyebrow !text-dawn-rose !mb-0">The app</p>
          </div>
          <h2 className="font-display text-3xl md:text-5xl lg:text-4xl xl:text-5xl leading-[1.08] tracking-tightish text-cream text-balance">
            {a.name}
          </h2>
          <p className="font-serif text-[17px] md:text-xl text-cream/80 mt-4 md:mt-5 leading-snug md:leading-relaxed max-w-xl md:mx-auto lg:mx-0">
            {a.tagline}
          </p>
          <AppPrice className="text-dawn-rose mt-5 md:mt-6" />
          <AppStoreButtons
            placement="home"
            tone="dark"
            className="mt-5 md:mt-7 md:justify-center lg:justify-start"
          />
          <Link
            to="/dharma"
            className="inline-flex items-center min-h-[44px] font-body text-xs tracking-widest2 uppercase text-cream/70 hover:text-dawn-rose transition-colors mt-3"
          >
            See what is inside →
          </Link>
        </div>
        <Link to="/dharma" aria-label="See the Dharma app" className="lg:col-span-7 block">
          <PhoneTrio screens={a.trio} className={TRIO_BOX} />
        </Link>
      </div>
    </section>
  );
}
